/**
 * CSV + PDF export buttons for the dashboard.
 */

import { Download, FileText } from 'lucide-react';
import { Button } from '@/components/ui/button';
import type { DashboardObservation } from '@/lib/dashboard/types';
import { exportCsv } from '@/lib/dashboard/exportCsv';
import { exportPdf } from '@/lib/dashboard/exportPdf';

export function ExportToolbar({ observations }: { observations: DashboardObservation[] }) {
  return (
    <div className="flex items-center gap-2">
      <Button
        variant="outline"
        size="sm"
        className="gap-2"
        onClick={() => exportCsv(observations)}
        disabled={observations.length === 0}
      >
        <Download className="h-4 w-4" />
        Export CSV
      </Button>
      <Button
        variant="outline"
        size="sm"
        className="gap-2"
        onClick={() => exportPdf(observations)}
        disabled={observations.length === 0}
      >
        <FileText className="h-4 w-4" />
        Export PDF
      </Button>
    </div>
  );
}
